<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text d-flex align-center justify-content-between">
        <v-tooltip color="white" v-if="contentJson?.lang?.[language]?.text || contentJson?.text" right content-class="tooltip-box-content" max-width="360" :open-delay="300" :close-delay="200" transition="slide-x-transition">
          <template v-slot:activator="{on, attrs}">
            <div v-bind="attrs" v-on="on" style="margin-right: -40px">
              {{ $t("heritage-protection") }}
              <span v-if="hasAtLeastOneWarning" style="color: red; font-size: 15px">&#9888;</span>
            </div>
          </template>
          <div v-html="contentJson?.lang?.[language]?.text || contentJson?.text"></div>
        </v-tooltip>
        <div v-else>
          {{ $t("heritage-protection") }}
          <span v-if="hasAtLeastOneWarning" style="color: red; font-size: 15px">&#9888;</span>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <TooltipTR section="section800" field="PRO_BUN" :label="$t('protected-building-nat')">
                <div>
                  {{ $t("protected-building-nat") }}
                  <span v-if="plotItem.PRO_BUN_LABEL == 'Y'" style="color: red; font-size: 20px;line-height: 1;">&#9888;</span>
                </div>
                <div>{{ plotItem.PRO_BUN }}</div>
              </TooltipTR>
              <TooltipTR section="section800" field="PRO_BUC" :label="$t('protected-building-cant')">
                <div>
                  {{ $t("protected-building-cant") }}
                  <span v-if="plotItem.PRO_BUC_LABEL == 'Y'" style="color: red; font-size: 20px;line-height: 1;">&#9888;</span>
                </div>
                <div>{{ plotItem.PRO_BUC }}</div>
              </TooltipTR>
              <TooltipTR section="section800" field="PRO_OOB" :label="$t('protected-objects')">
                <div>
                  {{ $t("protected-objects") }}
                  <span v-if="plotItem.PRO_OOB_LABEL == 'Y'" style="color: red; font-size: 20px;line-height: 1;">&#9888;</span>
                </div>
                <div>{{ plotItem.PRO_OOB }}</div>
              </TooltipTR>
              <TooltipTR section="section800" field="PRO_BOO" :label="$t('protected-botanical-objects')">
                <div>{{ $t("protected-botanical-objects") }}</div>
                <div>{{ plotItem.PRO_BOO }}</div>
              </TooltipTR>
              <TooltipTR section="section800" field="PRO_ARS" :label="$t('archaeological-protection-area')">
                <div>
                  {{ $t("archaeological-protection-area") }}
                  <span v-if="plotItem.PRO_ARS_LABEL == 'Y'" style="color: red; font-size: 20px;line-height: 1;">&#9888;</span>
                </div>
                <div>{{ plotItem.PRO_ARS }}</div>
              </TooltipTR>
              <TooltipTR section="section800" field="PRO_ARP" :label="$t('archaeological-site')">
                <div>
                  {{ $t("archaeological-site") }}
                  <span v-if="plotItem.PRO_ARP_LABEL == 'Y'" style="color: red; font-size: 20px;line-height: 1;">&#9888;</span>
                </div>
                <div>{{ plotItem.PRO_ARP }}</div>
              </TooltipTR>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator"
import TooltipTR from "./TooltipText.vue"

@Component({
  components: {TooltipTR},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem

  get hasAtLeastOneWarning() {
    if (this.plotItem.PRO_BUN_LABEL == "Y" || this.plotItem.PRO_BUC_LABEL == "Y" || this.plotItem.PRO_OOB_LABEL == "Y" || this.plotItem.PRO_ARS_LABEL == "Y" || this.plotItem.PRO_ARP_LABEL == "Y") {
      return true
    }
    return false
  }

  contentJson: any = {}
  language

  created() {
    this.language = localStorage.getItem("user-language") || "en"
    this.loadTooltip()
  }

  async loadTooltip() {
    this.contentJson = (await this.$store.dispatch("tooltip/getTooltipContent", "section800")) || {}
  }
}
</script>
